import { motion } from "framer-motion";
import { useContext } from "react";
import { GrBusinessService } from "react-icons/gr";
import { AppContext } from "../AppProvider";
import PracticeArea from "../Components/PracticeArea/PreacticeArea";
import { ImagesSlider } from "../Components/ui/images-slider";

const Practice = () => {
  const { images, IntroData } = useContext(AppContext);

  const practice = images.filter(
    (image) => image.caption && image.caption.toLowerCase().includes("sp")
  );

  return (
    <div className="mt-8">
      {images && (
        <ImagesSlider
          className="h-[30rem] rounded-t border-t border-l border-r border-gray-300"
          images={practice.map((item) => item.image)}
          overlay={true}
        >
          <motion.div
            initial={{ opacity: 0, y: -80 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9 }}
            className="z-50 flex flex-col justify-center items-center"
          >
            <motion.p
              className="font-extrabold text-xl md:text-6xl text-center py-4
        p-6 rounded-lg  text-white text-opacity-30 bg-clip-text  bg-center hover:backdrop-blur-md backdrop-filter hover:text-opacity-60"
            >
              Sectoral Presence
            </motion.p>
          </motion.div>
        </ImagesSlider>
      )}

      <p
        className="text-sm md:text-base lg:text-xl font-semibold min-h-10 bg-gradient-to-tr from-base_900 to-base_500 text-white flex items-center justify-start  px-3 mx-16 mb-2 gap-3 mt-8"
        data-aos="fade-right"
      >
        <span className="text-xl">
          {" "}
          <GrBusinessService />
        </span>
        Sectoral presence
      </p>
      <div
        dangerouslySetInnerHTML={{
          __html: IntroData?.practice_caption || "<p>No content available</p>",
        }}
        className="text-base font-sans font-normal text-blue-950 text-justify  py-10 mx-16"
        data-aos="fade-right"
      />
      <div className="flex flex-wrap  gap-6 px-6 my-10 lg:px-16 justify-center items-center">
        <PracticeArea />
      </div>
    </div>
  );
};

export default Practice;
